import { CookieCategory } from '../../types';

export const CONSENT_DISPLAYED_TEXT_ITEMS = [
	CookieCategory.Analytics,
	CookieCategory.Functional,
	CookieCategory.Marketing,
	CookieCategory.StrictlyNecessary,
	CookieCategory.Unknown,
];

const COUNTRIES_WITHIN_EU = [
	'AT', // Austria
	'BE', // Belgium
	'BG', // Bulgaria
	'CY', // Republic of Cyprus
	'CZ', // Czech Republic
	'DE', // Germany
	'DK', // Denmark
	'EE', // Estonia
	'ES', // Spain
	'FI', // Finland
	'FR', // France
	'GR', // Greece
	'HR', // Croatia
	'HU', // Hungary
	'IE', // Ireland
	'IT', // Italy
	'LT', // Lithuania
	'LU', // Luxembourg
	'LV', // Latvia
	'MT', // Malta
	'NL', // Netherlands
	'PL', // Poland
	'PT', // Portugal
	'RO', // Romania
	'SE', // Sweden
	'SI', // Slovenia
	'SK', // Slovakia
];

const COUNTRIES_WITHIN_EEA = [
	'IS', // Iceland
	'LI', // Liechtenstein
	'NO', // Norway
];

const COUNTRIES_FORMERLY_IN_EU = [
	'UK', // United Kingdom
	'GB', // United Kingdom (Great Britain)
];

// General Data Protection Regulation (GDPR) applies to all member states of the
// European Union (EU) and the European Economic Area (EEA)
export const COUNTRIES_PROTECTED_BY_GDPR = [
	...COUNTRIES_WITHIN_EU,
	...COUNTRIES_FORMERLY_IN_EU,
	...COUNTRIES_WITHIN_EEA,
];

// These countries do not yet have their own privacy protections in place, but Atlassian
// has decided they should be covered in the strictest policy group
export const COUNTRIES_CONSIDERED_TIER_1_BY_ATLASSIAN = [
	'CA', // Canada
	'CN', // China
	'IL', // Israel
	'JP', // Japan
	'QA', // Qatar
	'SG', // Singapore
	'ZA', // South Africa
	'KR', // South Korea - cited as Korea (the Republic of)
	'TR', // Turkey
	'TW', // Taiwan (Province of China)
	'HK', // Hong Kong
];

export const US_STATES_PROTECTED_BY_CPRA = [
	'US-CA', // California
];

export const COUNTRIES_PROTECTED_BY_LGPD = [
	'BR', // Brazil
];

export const COUNTRIES_PROTECTED_BY_FADP = [
	'CH', // Switzerland
];

// These countries have their own state-based privacy protections, so to remain extra compliant
// Atlassian deems these states to the same policy strictness level as CPRA (Tier 2)
export const US_STATES_CONSIDERED_TIER_2_BY_ATLASSIAN = [
	'US-CO', // Colorado
	'US-CT', // Connecticut
	'US-MT', // Montana
	'US-OR', // Oregon
	'US-TX', // Texas
	'US-UT', // Utah
	'US-VA', // Virginia
];

// Tier 1: Currently only country-based locales. Includes countries with their own privacy laws (GDPR, LGPD, FADP)
export const TIER_1_PROTECTED_LOCALES = [
	...COUNTRIES_CONSIDERED_TIER_1_BY_ATLASSIAN,
	...COUNTRIES_PROTECTED_BY_GDPR,
	...COUNTRIES_PROTECTED_BY_LGPD,
	...COUNTRIES_PROTECTED_BY_FADP,
];

// Tier 2: Currently only US locales
export const TIER_2_PROTECTED_LOCALES = [
	...US_STATES_PROTECTED_BY_CPRA,
	...US_STATES_CONSIDERED_TIER_2_BY_ATLASSIAN,
];

export const TIER_3_UNPROTECTED_LOCALES = [
	'AQ', // Antarctica
];
